import { render } from "./ContentNutriscore.vue?vue&type=template&id=3bfb880a"
import script from "./ContentNutriscore.vue?vue&type=script&lang=js"
export * from "./ContentNutriscore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__